<script setup lang="ts">
defineProps<{
  variant: PacketVariant
}>()

const btnClass = 'flex size-10 md:size-12 items-center justify-center rounded-sm bg-blue-50 enabled:hover:bg-blue-40 disabled:cursor-not-allowed disabled:bg-gray-20 [&>svg]:text-white'

const { quantity, min } = inject(keys.packetQuantity)!
</script>

<template>
  <div class="flex flex-col items-center gap-legacy-s">
    <label class="w-fit text-base font-normal text-black-80 md:text-lg" for="quantity">
      Antall tilganger:
    </label>

    <div class="flex gap-legacy-xs text-white">
      <button
        :disabled="quantity === min"
        :class="btnClass"
        aria-label="Reduser antall med 1"
        type="button"
        @click="quantity--"
      >
        <UIcon name="far:minus" />
      </button>
      <input
        id="quantity"
        v-model="quantity"
        class="w-20 rounded-sm border border-blue-40 px-legacy-xs py-legacy-2xs text-center text-gray-50"
        name="quantity"
        type="number"
        :min="min"
        :disabled="variant.fixedAmount"
        @focus="($event.target as HTMLInputElement).select()"
      />
      <button
        :class="btnClass"
        aria-label="Øk antall med 1"
        type="button"
        @click="quantity++"
      >
        <UIcon name="far:plus" />
      </button>
    </div>
  </div>
</template>
